import { mapPeOfferListItemFromApi } from './mapPeOfferFromApi';

const mapPeAssetsFromApi = (resp: ApiPeAssets): RemoteList<PeOfferListItem> => {
  return {
    items: resp.assets.map(mapPeOfferListItemFromApi),
  };
};

export default mapPeAssetsFromApi;
